import getStore from 'services/getStore';
import pubSub from 'services/pubSub';

const store = getStore();

const interactionsSeen = [] as any[];
let debounceScrolling;

let oldTopic;
let newTopic;
let topicUpdated;

let oldPosition = 0;
let newPosition = 0;

const clearHistory = () => {
  requestAnimationFrame(
    () =>
      (window.location.hash = Math.random()
        .toString(16)
        .substr(2, 8))
  );
  (window as any).locationHistory = null;
};

// when the pattern settles. all this will just publish an object with
// all this

const windowScrollInfo = (e, currentTopic) => {
  // return;

  if (currentTopic) {
    newTopic = currentTopic;
  }

  clearTimeout(debounceScrolling);

  debounceScrolling = setTimeout(() => {
    let scrollDirection;

    if (oldTopic !== newTopic) {
      topicUpdated = true;
      oldTopic = newTopic;
    } else {
      topicUpdated = false;
    }

    if (!topicUpdated) {
      newPosition = window.scrollY;

      if (oldPosition !== newPosition) {
        scrollDirection = oldPosition < newPosition ? 'down' : 'up';

        // either direction. might change. us direction for other things. . .
        if (
          window.locationHistory &&
          ['up', 'down'].includes(scrollDirection)
        ) {
          clearHistory();
        }

        oldPosition = newPosition;
      }
    }

    const sections = Array.from(document.querySelectorAll('section'));

    const sectionsInView: any = sections.reduce(
      ((acc, curr, index) => {
        const { top, height } = curr.getBoundingClientRect();

        return [
          ...acc,
          {
            section: curr,
            id: curr.id.replace(/i/, ''),
            inView: height
              ? top >= 0 - height / 2 && top <= window.innerHeight / 2
              : false,
            index,
          },
        ];
      }) as any,
      []
    );

    const sectionInView = sectionsInView.find(s => s.inView);

    if (window['sectionInView'] !== sectionInView) {
      window['sectionInView'] = sectionInView;

      // moving the focus biz back to the continue / back button. . .
      sections.forEach(section => {
        //
        // section.setAttribute('tabIndex', '-1');
        section.setAttribute('aria-hidden', 'true');
        section.removeAttribute('role');
      });

      if (sectionInView) {
        // sectionInView.section.setAttribute('tabIndex', '0');
        sectionInView.section.setAttribute('aria-hidden', 'false');
        sectionInView.section.setAttribute('role', 'main');
        // sectionInView.section.focus();

        pubSub.publish('SECTION_IN_VIEW', {
          sectionInView,
        });
      }
    }

    // console.log(sectionInView, window['sectionInView']);
    if (!window['sectionInView']) {
      return;
    }

    if (!interactionsSeen.includes(window['sectionInView'].id)) {
      interactionsSeen.push(window['sectionInView'].id);

      store.dispatch({
        type: 'UPDATE_INTERACTIONS_SEEN',
        data: {
          id: window['sectionInView'].id,
        },
      });
    }
  }, 100);
};

window.addEventListener('scroll', e => windowScrollInfo(e, null));

export default windowScrollInfo;
